import React from 'react';
import { SvgIcon, SvgIconProps } from '@material-ui/core';

export const LinkIcon16 = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 16 17">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.3333 8.06667C12.9647 8.06667 12.6667 8.36534 12.6667 8.73334V12.7333C12.6667 13.1007 12.368 13.4 12 13.4H4C3.632 13.4 3.33333 13.1007 3.33333 12.7333V4.73334C3.33333 4.366 3.632 4.06667 4 4.06667H8C8.36867 4.06667 8.66667 3.768 8.66667 3.4C8.66667 3.032 8.36867 2.73334 8 2.73334H4C2.89733 2.73334 2 3.63067 2 4.73334V12.7333C2 13.836 2.89733 14.7333 4 14.7333H12C13.1027 14.7333 14 13.836 14 12.7333V8.73334C14 8.36534 13.702 8.06667 13.3333 8.06667"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6632 4.06667L11.7185 4.072L7.52851 8.262C7.26784 8.52267 7.26784 8.944 7.52851 9.20467C7.65851 9.33467 7.82917 9.4 7.99984 9.4C8.17051 9.4 8.34117 9.33467 8.47117 9.20467L12.6658 5.01L12.6665 6.06734C12.6665 6.43534 12.9652 6.73334 13.3332 6.73334H13.3338C13.7018 6.73334 13.9998 6.43467 13.9998 6.066L13.9978 3.41267C13.9978 3.046 13.7012 2.74867 13.3345 2.74667L10.6698 2.73334H10.6665C10.2998 2.73334 10.0018 3.02934 9.99984 3.39667C9.99784 3.76467 10.2945 4.06467 10.6632 4.06667"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
